export function menuMain() {
    const menu = document.querySelector('#site-header');

    if (!menu) {
        return;
    }

    const parents = menu.querySelectorAll('.menu-parent');

    function toggleSubmenu(event) {
        const parent = event.currentTarget;
        const submenu = parent.nextElementSibling;
        const allSubmenus = document.querySelectorAll('.sub-menu');

        allSubmenus.forEach(function (item) {
            if (item !== submenu && item.classList.contains('sub-menu--visible')) {
                item.classList.remove('sub-menu--visible');
            }
        });

        submenu.classList.toggle('sub-menu--visible');

        // Check if any submenu is visible and toggle the "active" class on the menu
        if (document.querySelectorAll('.sub-menu--visible').length > 0) {
            menu.classList.add('menu-active');
            document.addEventListener('click', closeSubmenuOnClickOutside);
        } else {
            menu.classList.remove('menu-active');
            document.removeEventListener('click', closeSubmenuOnClickOutside);
        }

        // Prevent the event from bubbling up to the document
        event.stopPropagation();
    }

    function closeSubmenuOnClickOutside(event) {
        const allSubmenus = document.querySelectorAll('.sub-menu--visible');

        allSubmenus.forEach(function (submenu) {
            if (!submenu.contains(event.target) && !submenu.previousElementSibling.contains(event.target)) {
                submenu.classList.remove('sub-menu--visible');
            }
        });

        // Toggle the "active" class on the menu based on the visibility of submenus
        if (document.querySelectorAll('.sub-menu--visible').length === 0) {
            menu.classList.remove('menu-active');
            document.removeEventListener('click', closeSubmenuOnClickOutside);
        }
    }

    parents.forEach(function (parent) {
        parent.addEventListener('click', toggleSubmenu);
        //parent.addEventListener('focus', toggleSubmenu);
    });
}
